'use client'

import classNames from 'classnames'
import React, { useEffect } from 'react'
import { useState } from 'react'

import { ReactComponent as ArrowIcon } from '~/assets/icons/arrow-menu.svg'
import CMSButton from '~/components/button/cms'
import Link from '~/components/link'
import DashedDivider from '~/layouts/shared/dashed-divider'
import { IHeaderNavigation } from '~/types/global-options'
import { IStrapiLinkButton } from '~/types/strapi'

import MobileSubMenu from './mobile-submenu'

interface Properties {
  navigation: IHeaderNavigation[]
  headerButtons: IStrapiLinkButton[]
}

const MobileMenu: React.FC<Properties> = ({ headerButtons, navigation }) => {
  const [areOpened, setMenuOpened] = useState(false)
  const [subMenu, setSubMenu] = useState<number | string | false>(false)

  const onCliskSubMenu = () => {
    setSubMenu(false)
    setMenuOpened(false)
  }

  useEffect(() => {
    document.body.style.overflow = areOpened ? 'hidden' : 'auto'
    return () => {
      document.body.style.overflow = areOpened ? 'hidden' : 'auto'
    }
  }, [areOpened])

  useEffect(() => {
    const handleResize = () => {
      setMenuOpened(false)
    }
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <div className="ml-auto lg:hidden">
      <button
        className={classNames(
          'relative -translate-y-[2px] z-50 hamburger hamburger--spin !flex',
          {
            'is-active text-neutral-white': areOpened,
            'text-current': !areOpened,
          }
        )}
        type="button"
        aria-label="Menu"
        onClick={() => setMenuOpened(!areOpened)}
      >
        <span className="hamburger-box">
          <span className="hamburger-inner"></span>
        </span>
      </button>
      <div
        className={classNames(
          'pt-[4.375rem] fixed flex flex-col z-30 top-0 left-0 bg-wine-1000 w-full h-full overflow-y-auto transition-transform duration-300 ease-out',
          {
            'translate-x-[110%] pointer-events-none': !areOpened,
          }
        )}
      >
        <DashedDivider className="text-neutral-white" />
        <nav className="mobile-menu-nav px-7 pt-4 pb-8 flex flex-auto flex-col gap-4 items-start">
          {navigation?.map((navItem) => (
            <React.Fragment
              key={`mobile-nav-item-${navItem.__component}-${navItem.id}`}
            >
              {navItem.__component === 'common.link-simple-menu' ? (
                <>
                  <button
                    className="py-2 w-full flex uppercase text-neutral-white text-base items-center "
                    type="button"
                    onClick={() => setSubMenu(navItem.id)}
                  >
                    {navItem.name}

                    <ArrowIcon
                      className="-rotate-90 w-5 h-5"
                      width={20}
                      height={20}
                    />
                  </button>
                  <MobileSubMenu
                    active={navItem.id === subMenu}
                    itens={navItem.simpleMenuLinks}
                    onBack={() => setSubMenu(false)}
                    onClose={onCliskSubMenu}
                    title={navItem.name}
                  />
                </>
              ) : (
                <Link
                  href={navItem.url}
                  blank={navItem.blank}
                  className="menu-link w-full py-2 uppercase text-base text-neutral-white"
                  onClick={() => setMenuOpened(false)}
                >
                  {navItem.name}
                </Link>
              )}
            </React.Fragment>
          ))}
        </nav>
        <div className="flex flex-col w-full gap-4 mt-auto p-7">
          {headerButtons.map((button) => (
            <CMSButton
              key={`header-button-${button.id}`}
              attributes={button}
              className="text-center justify-center"
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default MobileMenu
